import React from "react";
import { MONTH_LABELS } from "../lib/results";

const MonthYearFilter = ({
  selectedYear,
  selectedMonthIndex,
  onYearChange,
  onMonthChange,
  currentYear,
  currentMonthIndex,
  idPrefix = "chart",
}) => {
  const yearOptions = [];
  for (let y = 2024; y <= currentYear; y += 1) yearOptions.push(y);

  const maxMonthIndex = selectedYear === currentYear ? currentMonthIndex : 11;

  return (
    <div className="filters">
      <div>
        <label htmlFor={`${idPrefix}-year`}>Select Year</label>
        <select
          id={`${idPrefix}-year`}
          value={selectedYear}
          onChange={(e) => onYearChange(Number(e.target.value))}
        >
          {yearOptions.map((y) => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label htmlFor={`${idPrefix}-month`}>Select Month</label>
        <select
          id={`${idPrefix}-month`}
          value={selectedMonthIndex}
          onChange={(e) => onMonthChange(Number(e.target.value))}
        >
          {MONTH_LABELS.filter((_, idx) => idx <= maxMonthIndex).map(
            (name, idx) => (
              <option key={name} value={idx}>
                {name}
              </option>
            )
          )}
        </select>
      </div>
    </div>
  );
};

export default MonthYearFilter;
